/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import DevIcon from '../../../../../../../libs/common/src/assets/iconComponents/dev-icon';
import ApplicationsIcon from '../../../../../../../libs/common/src/assets/iconComponents/applications-icon';
import ApiIcon from '../../../../../../../libs/common/src/assets/iconComponents/api-icon';

import {
  ROUTE_DEVELOPER_DASHBOARD,
  ROUTE_DEVELOPER_DASHBOARD_API_REFERENCES,
  ROUTE_DEVELOPER_DASHBOARD_SANDBOXES,
} from '@developer/constants';

export const dashboardDevelopersTabs = {
  dashboard: {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    img: <DevIcon />,
    title: 'developer_portal_navigation_dashboard',
    id: 'dashboard',
    link: ROUTE_DEVELOPER_DASHBOARD,
    content: null,
  },
  sandboxes: {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    img: <ApplicationsIcon />,
    id: 'sandboxes',
    title: 'developer_portal_navigation_sandboxes',
    link: ROUTE_DEVELOPER_DASHBOARD_SANDBOXES,
    content: 'Sandboxes page',
  },
  apiReferences: {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    img: <ApiIcon />,
    id: 'apiReferences',
    title: 'developer_portal_navigation_references',
    link: ROUTE_DEVELOPER_DASHBOARD_API_REFERENCES,
    content: 'API Reference page',
  },
};
